// src/components/dialog/DlgUserPoolInfo.tsx

import {
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material'

import { UserPool } from '@/types/domain/user'
import { KARMA_BasicDialog } from '@/types/karma/dialog'

import {
  FILTER_ADMIN_ROLE,
  FILTER_COACH_ROLE,
  FILTER_GUEST_ROLE,
  FILTER_INACTIVE_USER,
  FILTER_UNCONFIRMED_USER,
  FILTER_USER_ROLE,
} from '../../api/'
import { DlgCloseButton, HStack } from '../../components'
import { languageConstants as LC } from '../../constants'
import { useUserPool } from '../../hooks'

type StatRecordProps = {
  label: any
  value: any
  sx?: any
}

const StatRecord = ({ label, value, ...rest }: StatRecordProps) => (
  <HStack spacing={2} sx={{ width: 1 }} {...rest}>
    <Stack sx={{ flex: 1, textAlign: 'right' }}>
      <Typography>{label}</Typography>
    </Stack>

    <Stack sx={{ flex: 1, textAlign: 'left' }}>
      <Typography>{value}</Typography>
    </Stack>
  </HStack>
)

const UserPoolStatistics = () => {
  const uPool: UserPool = useUserPool()

  return (
    <Stack sx={{ mt: 3 }}>
      <StatRecord label={'Poolgröße'} value={uPool.length} />

      <StatRecord
        label={<strong>Rollen</strong>}
        value={null}
        sx={{ my: 1, pr: 1, textAlign: 'right' }}
      />

      {[
        {
          label: LC.USERROLE_USER,
          value: uPool.filter(FILTER_USER_ROLE).length,
        },
        {
          label: LC.USERROLE_GUEST,
          value: uPool.filter(FILTER_GUEST_ROLE).length,
        },
        {
          label: LC.USERROLE_COACH,
          value: uPool.filter(FILTER_COACH_ROLE).length,
        },
        {
          label: LC.USERROLE_ADMIN,
          value: uPool.filter(FILTER_ADMIN_ROLE).length,
        },
      ].map(item => (
        <StatRecord key={item.label} label={item.label} value={item.value} />
      ))}

      <StatRecord
        label={<strong>Inaktiv</strong>}
        value={null}
        sx={{ my: 1, pr: 1, textAlign: 'right' }}
      />

      {[
        {
          label: LC.USERSTATUS_INACTIVE,
          value: uPool.filter(FILTER_INACTIVE_USER).length,
        },
        {
          label: LC.USERSTATUS_NOT_CONFIRMED,
          value: uPool.filter(FILTER_UNCONFIRMED_USER).length,
        },
      ].map(item => (
        <StatRecord key={item.label} label={item.label} value={item.value} />
      ))}
    </Stack>
  )
}

export const DlgUserPoolInfo = ({ onClose, open }: KARMA_BasicDialog) => (
  <Dialog fullWidth open={open}>
    <DialogTitle>
      <Typography>User Pool Info</Typography>

      <DlgCloseButton onClick={onClose} />
    </DialogTitle>

    <DialogContent>
      <UserPoolStatistics />
    </DialogContent>
  </Dialog>
)
